/**
 * QR Code Helper
 * Automatically renders QR codes for elements with [data-qr-value]
 */

const initializeQRCodes = () => {
  const qrCodeElements = document.querySelectorAll("[data-qr-value]");
  if (qrCodeElements.length === 0) return;

  const render = () => {
    // Attempt to use the globally exposed QRCode from the bundle
    const qrClient = typeof cs !== "undefined" ? cs.QRCode : null;

    if (qrClient) {
      qrCodeElements.forEach((el) => {
        const rawValue = el.getAttribute("data-qr-value");
        if (rawValue) {
          const value =
            rawValue.startsWith("/") && typeof window !== "undefined" && window.location?.origin
              ? window.location.origin + rawValue
              : rawValue;
          qrClient.toCanvas(
            el,
            value,
            {
              width: el.dataset.qrSize || 200,
              margin: 2,
              color: {
                dark: el.dataset.qrDark || "#31316A",
                light:
                  el.dataset.qrTransparent === "true" || el.dataset.qrLight === "transparent"
                    ? "#00000000"
                    : el.dataset.qrLight || "#ffffffff",
              },
            },
            (error) => {
              if (error) console.error("QR Code rendering failed:", error);
            },
          );
        }
      });
    } else {
      // Library not yet available, retry shortly
      setTimeout(render, 50);
    }
  };

  render();
};

// Initialize on DOM load
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeQRCodes);
} else {
  initializeQRCodes();
}
